/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetRouteOriginDestinationNotFound
 */
export interface GetRouteOriginDestinationNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetRouteOriginDestinationNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetRouteOriginDestinationNotFound interface.
 */
export function instanceOfGetRouteOriginDestinationNotFound(value: object): value is GetRouteOriginDestinationNotFound {
    return true;
}

export function GetRouteOriginDestinationNotFoundFromJSON(json: any): GetRouteOriginDestinationNotFound {
    return GetRouteOriginDestinationNotFoundFromJSONTyped(json, false);
}

export function GetRouteOriginDestinationNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRouteOriginDestinationNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetRouteOriginDestinationNotFoundToJSON(json: any): GetRouteOriginDestinationNotFound {
    return GetRouteOriginDestinationNotFoundToJSONTyped(json, false);
}

export function GetRouteOriginDestinationNotFoundToJSONTyped(value?: GetRouteOriginDestinationNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

